export default __webpack_public_path__ + "79d4f2469acfc830b4f456e3b9ae5b2f.png";